// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { useEffect } from 'react';

import Form from '@cloudscape-design/components/form';


import { removeCookie, setIdUser, setName } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';

export const UserLogoffPage = () => {

    const { idUser, name } = useGlobalState();
    setIdUser(0)
    setName('')
    removeCookie("JWT");
    useEffect(() => {
        window.location.href = "#user/login"
    }, [idUser]);

    return (
        <Form></Form>
    );

};
